"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionSubjectSearchBar = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var useMappedPermissions_1 = require("./useMappedPermissions");
var PermissionSubjectSearchResults_1 = require("./PermissionSubjectSearchResults");
var SetPermissionsMenu_1 = require("./SetPermissionsMenu");
var usePermissionObject_1 = require("./usePermissionObject");
var usePermissionsModalContext_1 = require("./usePermissionsModalContext");
var PermissionUpdateSubmitButton = function (_a) {
    var permissionLevel = _a.permissionLevel, selectedSuggestion = _a.selectedSuggestion, onClear = _a.onClear, children = _a.children, props = __rest(_a, ["permissionLevel", "selectedSuggestion", "onClear", "children"]);
    var _js = (0, usePermissionsModalContext_1.usePermissionsModalContext)()._js;
    var _b = (0, usePermissionObject_1.usePermissionObject)(), objectType = _b.objectType, objectId = _b.objectId;
    var _c = (0, usePermissionsModalContext_1.usePermissionsModalContext)(), useSetTeamPermission = _c.useSetTeamPermission, useSetUserPermission = _c.useSetUserPermission;
    var setTeamPermission = useSetTeamPermission(objectType, objectId);
    var setUserPermission = useSetUserPermission(objectType, objectId);
    var onSubmit = React.useCallback(function (event) {
        event.preventDefault();
        if (!selectedSuggestion || !permissionLevel) {
            return;
        }
        if (selectedSuggestion.type === 'team') {
            setTeamPermission.mutate({
                teamids: [selectedSuggestion.id],
                permissionLevel: permissionLevel,
            }, {
                onSuccess: function () {
                    onClear();
                },
            });
        }
        else {
            setUserPermission.mutate({
                userids: [selectedSuggestion.id],
                permissionLevel: permissionLevel,
            }, {
                onSuccess: function () {
                    onClear();
                },
            });
        }
    }, [selectedSuggestion, permissionLevel]);
    var existingPermissions = (0, useMappedPermissions_1.useMappedPermissions)(objectType, objectId);
    var submitText = React.useMemo(function () {
        if (!selectedSuggestion) {
            return _js('Add');
        }
        return (selectedSuggestion.type === 'team' &&
            existingPermissions.teams.has(selectedSuggestion.id)) ||
            (selectedSuggestion.type === 'user' &&
                existingPermissions.users.has(selectedSuggestion.id))
            ? _js('Update')
            : _js('Add');
    }, [selectedSuggestion, existingPermissions]);
    return (React.createElement(react_1.Button, __assign({ colorScheme: "blue", variant: "solid", paddingX: 6, isDisabled: !selectedSuggestion ||
            !permissionLevel ||
            setTeamPermission.isLoading ||
            setUserPermission.isLoading, isLoading: setTeamPermission.isLoading || setUserPermission.isLoading, onClick: onSubmit, "data-feature-id": "permissions-modal-submit" }, props), submitText));
};
var PermissionSubjectSearchInput = function (_a) {
    var searchQuery = _a.searchQuery, onSearchQueryChange = _a.onSearchQueryChange, selectedSuggestion = _a.selectedSuggestion, onSelect = _a.onSelect, onClear = _a.onClear, inputRef = _a.inputRef;
    var _js = (0, usePermissionsModalContext_1.usePermissionsModalContext)()._js;
    return (React.createElement(react_1.Box, { flex: "2", zIndex: 1 },
        React.createElement(react_1.FormLabel, null, _js('User or Team')),
        React.createElement(react_1.InputGroup, null,
            selectedSuggestion && (React.createElement(react_1.InputLeftElement, { width: "auto", marginLeft: 2 },
                React.createElement(react_1.Tag, null,
                    React.createElement(react_1.TagLabel, { isTruncated: true, maxWidth: 32 }, selectedSuggestion.name),
                    React.createElement(react_1.TagCloseButton, { onClick: onClear })))),
            React.createElement(react_1.Box, { sx: {
                    width: '100%',
                    '& > div': {
                        top: '100% !important',
                        width: '100% !important',
                    },
                } },
                React.createElement(react_1.Input, { id: "permissions-modal-search", ref: inputRef, value: searchQuery, onChange: onSearchQueryChange, isDisabled: Boolean(selectedSuggestion), maxLength: 255 }),
                React.createElement(PermissionSubjectSearchResults_1.PermissionSubjectSearchResults, { searchQuery: searchQuery, onSelect: onSelect })))));
};
var PermissionSubjectSearchBar = function (_a) {
    var inputRef = _a.inputRef;
    var _b = (0, usePermissionObject_1.usePermissionObject)(), objectType = _b.objectType, objectId = _b.objectId;
    var usePermissionLevels = (0, usePermissionsModalContext_1.usePermissionsModalContext)().usePermissionLevels;
    var _c = React.useState(''), searchQuery = _c[0], setSearchQuery = _c[1];
    var _d = React.useState(null), selectedSuggestion = _d[0], setSelectedSuggestion = _d[1];
    var permissionLevels = usePermissionLevels(objectType, objectId).data;
    var _e = React.useState(permissionLevels === null || permissionLevels === void 0 ? void 0 : permissionLevels[0]), permissionLevel = _e[0], setPermissionLevel = _e[1];
    React.useEffect(function () {
        if (!permissionLevel && (permissionLevels === null || permissionLevels === void 0 ? void 0 : permissionLevels.length)) {
            setPermissionLevel(permissionLevels[0]);
        }
    }, [permissionLevels]);
    var handleSearchQueryChange = React.useCallback(function (event) {
        setSearchQuery(event.target.value);
    }, []);
    var handleSuggestionSelect = React.useCallback(function (suggestion) {
        setSelectedSuggestion(suggestion);
        setSearchQuery(suggestion.name);
        setSearchQuery('');
    }, []);
    var clearSelectedSuggestion = React.useCallback(function () {
        setSelectedSuggestion(null);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(react_1.FormControl, null,
            React.createElement(react_1.Stack, { direction: "row", align: "flex-end", mt: 2, spacing: 4 },
                React.createElement(PermissionSubjectSearchInput, { searchQuery: searchQuery, onSearchQueryChange: handleSearchQueryChange, selectedSuggestion: selectedSuggestion, onSelect: handleSuggestionSelect, onClear: clearSelectedSuggestion, inputRef: inputRef }),
                React.createElement(SetPermissionsMenu_1.SetPermissionsMenu, { buttonVariant: "outline", permissionLevel: permissionLevel, onChange: setPermissionLevel }),
                React.createElement(PermissionUpdateSubmitButton, { permissionLevel: permissionLevel, selectedSuggestion: selectedSuggestion, onClear: clearSelectedSuggestion })))));
};
exports.PermissionSubjectSearchBar = PermissionSubjectSearchBar;
